import React from 'react';

import BackgroundImage from '../../../components/BackgroundImage';

const background = require('../../../assets/images/404.jpg');

export const SomethingWentWrong = () => (
  <div className="staff-home">
    <BackgroundImage src={background} className="staff-home-bg" alt="bg-image">
      <div className="admin-wrapper">
        <div className="clubs-picker-layout not-found-page">
          <h1>Something Went Wrong</h1>

          <h2>We could not process your request successfully.</h2>

          <h3>Please, go back and try again</h3>
        </div>
      </div>
    </BackgroundImage>
  </div>
);
